import React from "react";
import { MESSAGE_TYPES, MessageType } from "../../constants/Messages";

interface StaticAlertBannerProps {
    title?: string; // Optional title for the alert
    message: string; // The message to display
    message_type: MessageType; // Alert type
    onClose: () => void; // Callback for closing the alert
    className?: string; // Optional custom className
    isHtml?: boolean; // If true, interpret `message` as HTML
}

const StaticAlertBanner: React.FC<StaticAlertBannerProps> = ({
                                                                 title,
                                                                 message,
                                                                 message_type,
                                                                 onClose,
                                                                 className,
                                                                 isHtml = false,
                                                             }) => {
    return (
        <div
            className={`relative w-full flex flex-col z-50 py-4 ${className || ""}`}
        >
            <div
                className={`relative w-full p-4 rounded shadow-md flex justify-between items-start 
                ${
                    message_type === MESSAGE_TYPES.SUCCESS
                        ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-200"
                        : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-200"
                }`}
            >
                <div>
                    {title && (
                        <span className="text-sm-md sm:text-md font-bold mb-2 block">
                            {title}
                        </span>
                    )}
                    {isHtml ? (
                        <span
                            className="text-sm sm:text-md font-medium"
                            dangerouslySetInnerHTML={{ __html: message }} // Use HTML rendering
                        />
                    ) : (
                        <span className="text-sm sm:text-md font-medium whitespace-pre-line">
                            {message}
                        </span>
                    )}
                </div>
                <a
                    onClick={onClose}
                    className="ml-4 text-md font-medium text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 focus:outline-none"
                    aria-label="Close alert"
                >
                    ✕
                </a>
            </div>
        </div>
    );
};

export default StaticAlertBanner;